import { ChampionshipSettings } from 'modules/championship/domain/interfaces/championship-settings';
import { GameDetails } from 'modules/games/domain/interfaces/game-details';
import gameRepository from 'modules/games/domain/repositories/game-repository';
import { getPeriodsSettings } from 'modules/games/domain/utils/match-periods-settings';
import { baseApi } from 'shared/api/base-api';
import { toApiError } from 'shared/errors';
import { RootState } from 'store/store';

export interface ReviewMatchArgs {
  matchId: number;
  championshipId: number;
}

/**
 * The match a review is assembled for: protocol goals, teams with logos and rosters, score, date, place.
 *
 * The same request as the match protocol (`fetchGameDetails`), but in the RTK Query cache and not in the protocol's
 * slice: the «Видео» tab must not overwrite an open protocol, and switching matches back and forth costs no request.
 * Event minutes depend on the championship's period settings — taken from the open championship, as the protocol does.
 */
export const reviewMatchApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    reviewMatch: build.query<GameDetails, ReviewMatchArgs>({
      async queryFn({ matchId, championshipId }, api) {
        try {
          const state = api.getState() as RootState;
          const settings = state.championships.championship.data?.byId[championshipId]?.settings ?? ({} as ChampionshipSettings);
          return { data: await gameRepository.fetchGameDetails(matchId, getPeriodsSettings(settings)) };
        } catch (error) {
          return { error: toApiError(error) };
        }
      },
    }),
  }),
});

export const { useReviewMatchQuery } = reviewMatchApi;
